import { useOrganization } from '../useOrganization';
import { calculateOrganisationColors, FJELL } from './organization-theme-model';

export const PRIMARY_ORGANIZATION_COLOR = 'primary-organization-color';
export const SECONDARY_ORGANIZATION_COLOR = 'secondary-organization-color';
export const TERTIARY_ORGANIZATION_COLOR = 'tertiary-organization-color';
export const WHITE_ORGANIZATION_COLOR = 'white-organization-color';
export const SAND_ORGANIZATION_COLOR = 'sand-organization-color';
export const SAND_SECONDARY_ORGANIZATION_COLOR = 'sand-secondary-organization-color';

export const OrganizationTheme = ({ children, className, theme }) => {
    const organization = useOrganization();

    const themeColor = organization?.themeColor;

    const {
        secondaryColor,
        primaryColor,
        tertiaryColor,
        sandColor,
        primaryTextColor,
        secondaryTextColor,
        tertiaryTextColor,
        sandTextColor,
        hoverColor,
    } = calculateOrganisationColors(themeColor);

    if (theme === SAND_ORGANIZATION_COLOR && themeColor) {
        theme = PRIMARY_ORGANIZATION_COLOR;
    } else if (theme === SAND_SECONDARY_ORGANIZATION_COLOR && themeColor) {
        theme = SECONDARY_ORGANIZATION_COLOR;
    }

    return (
        <>
            <style>
                {`
                ${
                    primaryColor
                        ? `
                    .${PRIMARY_ORGANIZATION_COLOR} {
                        background-color: ${primaryColor};
                        border-color: ${primaryColor};
                        color: ${primaryTextColor};
                        --ffe-color-component-button-primary-fill-default: ${primaryColor};
                        --ffe-color-component-button-primary-fill-hover: ${hoverColor};
                        --ffe-color-component-button-primary-fill-pressed: ${hoverColor};
                        --ffe-color-component-button-primary-border-default: ${primaryColor};
                        --ffe-color-component-button-primary-foreground-default: ${primaryTextColor};
                        --ffe-color-component-button-action-fill-default: ${primaryColor};
                        --ffe-color-component-button-action-fill-hover: ${hoverColor};
                        --ffe-color-component-button-action-fill-pressed: ${hoverColor};
                        --ffe-color-component-button-action-border-default: ${primaryColor};
                        --ffe-color-component-button-action-foreground-default: ${primaryTextColor};
                        --rounded-button-important-hover-background-color: ${hoverColor};
                        --rounded-button-important-background-color: ${hoverColor};
                        --ffe-color-foreground-emphasis: ${primaryTextColor};
                        --ffe-color-foreground-default: ${primaryTextColor};
                        --rounded-button-primary-hover-background-color: ${hoverColor};
                        --rounded-button-primary-background-color: ${primaryColor};
                        --rounded-button-primary-border-color: ${primaryColor};
                        --rounded-button-primary-text-color: ${primaryTextColor};
                        --border-focus-color: ${primaryColor};
                        --ffe-color-foreground-interactive-link:${primaryTextColor};
                    }
                    .${WHITE_ORGANIZATION_COLOR} {
                        --ffe-color-component-button-secondary-fill-default: #FFF;
                        --ffe-color-component-button-secondary-fill-hover: #EEE;
                        --ffe-color-component-button-secondary-border-default: #262626;
                        --ffe-color-component-button-secondary-border-hover: #262626;
                        --ffe-color-component-button-secondary-foreground-default: #262626;
                        --ffe-color-component-button-secondary-foreground-hover: #262626;
                        --ffe-color-foreground-emphasis: #1a1a1a;
                        --rounded-button-secondary-hover-background-color: #EEE;
                        --rounded-button-secondary-hover-border-color: #262626;
                        --rounded-button-secondary-hover-text-color: #262626;
                        --rounded-button-primary-hover-background-color: #EEE;
                        --rounded-button-primary-hover-text-color: #262626;
                        --border-focus-color: ${primaryColor};
                    }
                    `
                        : `
                    .${SAND_ORGANIZATION_COLOR} {
                        background-color: ${sandColor};
                        border-color:  ${sandColor};
                        color: ${sandTextColor};
                        --ffe-color-foreground-default: ${sandTextColor};
                        --ffe-color-foreground-emphasis: ${FJELL};
                        --rounded-button-secondary-hover-background-color: ${primaryColor};
                        --rounded-button-secondary-hover-text-color:${primaryTextColor};
                        --border-focus-color: ${primaryColor};
                    }
                    `
                }
                    .${SECONDARY_ORGANIZATION_COLOR} {
                        background-color: ${secondaryColor};
                        border-color: ${secondaryColor};
                        color: ${secondaryTextColor};
                        --ffe-color-foreground-default: ${secondaryTextColor};
                        --ffe-color-foreground-emphasis: ${secondaryTextColor};
                        --ffe-color-foreground-interactive-link: ${secondaryTextColor};
                    }

                    .${TERTIARY_ORGANIZATION_COLOR} {
                        background-color: ${tertiaryColor};
                        border-color: ${tertiaryColor};
                        color: ${tertiaryTextColor};
                        --ffe-color-foreground-default: ${tertiaryTextColor};
                        --ffe-color-foreground-emphasis: ${tertiaryTextColor};
                        --ffe-color-foreground-interactive-link: ${tertiaryTextColor};
                        fill: ${secondaryColor}
                    }

                    .${SAND_SECONDARY_ORGANIZATION_COLOR} {
                        background-color: ${sandColor};
                        border-color:  ${sandColor};
                        color: ${sandTextColor};
                        --ffe-color-foreground-default: ${sandTextColor};
                        --ffe-color-foreground-emphasis: ${FJELL};
                    }
                `}
            </style>
            <div className={[className, theme].join(' ')}>{children}</div>
        </>
    );
};
